import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { orderService } from "@/services/api/cresivoxServer";


import { iOrderDataById, iOrderList,iUpdatedAddress, iCreateOrderRequest,REDUCER_NAME, iOrderItem} from "./Types";
import { AnyARecord } from "dns";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

const getResponseMessage = (value: unknown, fallback: string) => {
	if (typeof value === "string" && value.trim()) {
		return value;
	}

	if (value && typeof value === "object") {
		const nestedMessage = (value as {message?: unknown}).message;
		if (typeof nestedMessage === "string" && nestedMessage.trim()) {
			return nestedMessage;
		}
	}

	return fallback;
};

  export const getOrderList = createAsyncThunk<
  iGenericResponse<any | null> | null,
{status:string; page?: number; limit?: number},
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("orderList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({status, page, limit}, {rejectWithValue}) => {
	  try {
		  const response = await orderService.getOrderList(status, page, limit);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getOrderById = createAsyncThunk<
iGenericResponse<iOrderDataById | null> | null,
{orderId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("orderById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await orderService.getOrderById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data?.order,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateOrder = createAsyncThunk<
iGenericResponse<any | null> | null,
{ orderId: string, billingAddress: iUpdatedAddress, shippingAddress: iUpdatedAddress, paymentMethod: string, note: string, shippingMethod: string,status:string,orderItems:iOrderItem },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updaeOrder"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
	async (payload, {rejectWithValue}) => {
		try {
			const response = await orderService.updateOrder(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data?.order,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const deleteOrder = createAsyncThunk<
iGenericResponse<any | null> | null,
{orderId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteorder"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await orderService.deleteOrder(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data?.order,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const forwardOrderToWHolesaler = createAsyncThunk<
iGenericResponse<any | null> | null,
{orderId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("forwardOrderToWHolesaler"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({orderId}, {rejectWithValue}) => {
	try {
		const response = await orderService.forwardOrderToWHolesaler(orderId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data?.order,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const createOrder = createAsyncThunk<
iGenericResponse<any | null> | null,
iCreateOrderRequest,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("createOrder"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
	async (payload, {rejectWithValue}) => {
		try {
			const response = await orderService.createOrder(payload);
			if (response) {
				const {httpStatusCode, data, message} = response;
				const normalizedMessage = getResponseMessage(
					data && typeof data === "object" ? (data as {message?: unknown}).message ?? message : message,
					"Order created successfully",
				);

				switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK:
				case httpStatusCodes.SUCCESS_CREATED: { // Add handling for 201 status
				  // Return success response even if data.data is not present
				  return {
					httpStatusCode,
					data: data,
					message: normalizedMessage,
				  };
				}
				default: {
				  return rejectWithValue({
					httpStatusCode,
					message: getResponseMessage(
						data && typeof data === "object" ? (data as {message?: unknown}).message ?? message : message,
						"Failed to create order",
					),
				  });
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const getForwardOrderItems = createAsyncThunk<
  iGenericResponse<any | null> | null,
{orderId:string},
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getForwardOrderItems"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({orderId}, {rejectWithValue}) => {
	  try {
		  const response = await orderService.getForwardOrderItems(orderId);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);
